import { QuoteChargeListingEntity, QuoteChargeType } from "../types";
import { CreateOrUpdateQuoteVariables } from "../api/types";
import { ChargeAttachType } from "../../equipment/types";

export function collectQuoteFromInvoiceForm(
  input: QuoteChargeListingEntity[]
): Omit<CreateOrUpdateQuoteVariables["input"], "vendorOpportunityId"> {
  const equipments = input
    .filter(({ type }) => type === QuoteChargeType.Equipment)
    .map(({ equipment }) => ({
      attributes: [],
      externalId: "",
      cost: equipment!.price.retailPrice,
      equipmentId: equipment!.equipmentId,
      stockNumber: equipment!.stockId ?? "",
      vin: equipment!.serialNumberVin ?? "",
    }));

  const fees = input
    .filter(({ type }) => type === QuoteChargeType.Invoice)
    .map(({ charge }) => ({
      type: charge!.type,
      description: charge!.label,
      amount: charge!.retailPrice,
      equipmentId: charge!.attachTo.type === ChargeAttachType.Equipment ? charge!.attachTo.id : null,
    }));

  return {
    term: null,
    fees: fees,
    downPayment: null,
    interestRate: null,
    paymentAmount: null,
    equipment: equipments,
    contractStartDate: null,
    firstPaymentDueDate: null,
    rebates: [],
    attributes: [],
    cashBackAmounts: [],
    equipmentTradeIns: [],
    aftermarketProducts: [],
  };
}
